import React from 'react'

import { Container } from '../../components/Bootstrap'
import Hero from '../../components/Hero'
import Layout from '../../components/Layout'
import Navigation from '../../components/Navigation'
import Summary from '../../components/Summary'
import TagCloud from '../../components/TagCloud'

import { bold } from '../../styles'

const data = [
  { text: 'CILT', size: 1.4 },
  { text: 'experience', size: 0.9 },
  { text: 'Direct', size: 1.6 },
  { text: 'Funding', size: 1.5 },
  { text: 'organization', size: 0.9 },
  { text: 'providing', size: 1.5 },
  { text: 'support', size: 1.1 },
  { text: 'disabilities', size: 1.6 },
  { text: 'peer', size: 1.1 },
  { text: 'support', size: 1.1 },
  { text: 'people', size: 1.6 },
  { text: 'strong', size: 1 },
  { text: 'programs', size: 1.8 },
  { text: 'living', size: 1.4 },
  { text: 'independent', size: 1.6 },
  { text: 'well', size: 0.9 },
  { text: 'staff', size: 1.3 },
  { text: 'knowledge', size: 0.9 },
  { text: 'community', size: 1.3 },
  { text: 'parenting', size: 0.9 },
  { text: 'consumer', size: 1.2 },
  { text: 'people', size: 1.1 },
]

const AllSeven = () => (
  <Layout>
    <Hero>
      <h1>Question 7</h1>
      <p className={bold}>In your opinion, what are the strengths of the Centre for Independent Living Toronto (CILT)?</p>
    </Hero>
    <Container>
      <Navigation prev="/all/6" next="/all/8" />
      <TagCloud words={data} />
	  <Summary>The world cloud shows that the words most often used to describe CILT’s strengths are “Direct Funding” “providing” “Disabilities” “programs” living” “independent” “community”.</Summary>
    </Container>
  </Layout>
)

export default AllSeven
